var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-scrollbar",
        { staticStyle: { height: "80vh" } },
        [
          _c("div", [_vm._v("转化效果图：")]),
          _c(
            "div",
            { staticStyle: { margin: "20px 0" } },
            [
              _c("el-button", { attrs: { size: "mini" } }, [
                _vm._v("跟进时间")
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "240px", "margin-right": "10px" },
                attrs: {
                  size: "mini",
                  type: "datetimerange",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  "range-separator": "~",
                  editable: false,
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  clearable: "",
                  "default-time": ["00:00:00", "23:59:59"]
                },
                model: {
                  value: _vm.dateTime,
                  callback: function($$v) {
                    _vm.dateTime = $$v
                  },
                  expression: "dateTime"
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c("div", {
              staticStyle: { height: "400px", width: "30vw" },
              attrs: { id: "left" }
            }),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("div", [_vm._v("上门转化率：")]),
                    _c("div", {
                      staticStyle: { height: "200px", width: "250px" },
                      attrs: { id: "middle" }
                    })
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("div", [_vm._v("成交转化率：")]),
                    _c("div", {
                      staticStyle: { height: "200px", width: "250px" },
                      attrs: { id: "middle1" }
                    })
                  ]
                )
              ]
            ),
            _c("div", { staticClass: "right" }, [
              _c("div", { staticClass: "item" }, [_vm._v("说明：")]),
              _c("div", { staticClass: "item" }, [
                _vm._v("线索：指触发了营销雷达从而产生线索的客户数量。")
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v("跟进：指跟进线索分配了跟进人的客户数量。")
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v("上门：指跟进后，最终上门的客户数量。")
              ]),
              _c("div", { staticClass: "item" }, [
                _vm._v("成交：指跟进后，最终成交的客户数量。")
              ])
            ])
          ]),
          _c("div", [_vm._v("员工明细表：")]),
          _c(
            "div",
            { staticStyle: { margin: "20px 0" } },
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "mini",
                      "suffix-icon": "el-icon-search",
                      placeholder: "员工姓名",
                      clearable: ""
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { size: "mini" }
                    },
                    [_vm._v("跟进时间")]
                  ),
                  _c("el-date-picker", {
                    staticStyle: { width: "240px", "margin-right": "10px" },
                    attrs: {
                      size: "mini",
                      type: "datetimerange",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "range-separator": "~",
                      editable: false,
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      clearable: "",
                      "default-time": ["00:00:00", "23:59:59"]
                    },
                    model: {
                      value: _vm.dateTime,
                      callback: function($$v) {
                        _vm.dateTime = $$v
                      },
                      expression: "dateTime"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticStyle: { height: "50px" } }),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#eef1f6" }
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "follower", label: "员工姓名" }
              }),
              _c("el-table-column", {
                attrs: { prop: "department", label: "所属部门" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "statusABCCount",
                  label: "跟进人数",
                  sortable: ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "statusABCount",
                  label: "上门人数",
                  sortable: ""
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "statusACount", label: "成交人数", sortable: "" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "statusAAmount",
                  label: "成交金额",
                  sortable: ""
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "abratio", label: "上门转化率", sortable: "" }
              }),
              _c("el-table-column", {
                attrs: { prop: "aratio", label: "成交转化率", sortable: "" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }